$(document).ready(function () {
  handleStickyHeader();

  $(".menu-drawer__accordion-head").click(function() {
    $(this).toggleClass("opened");
  })

  // MOBILE LOGO
  function switchLogoBasedOnWidth() {
    const logo = document.querySelector('.responsive-logo');
    if (!logo) return;

    const mobileLogo = logo.getAttribute('data-mobile-logo');
    const desktopLogo = logo.getAttribute('data-desktop-logo');

    if (window.innerWidth < 767) {
      logo.src = mobileLogo;
    } else {
      logo.src = desktopLogo;
    }
  }

  // ROLLING TEXT MODULE

  if ($('.slick-marquee').length && typeof $.fn.slick === 'function') {
    $('.slick-marquee').slick({
      speed: 5800,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 1,
      variableWidth: true,
      infinite: true,
      arrows: false,
      buttons: false,
      pauseOnHover: true
    });

  }

  // QUICKLINKS SLIDER MODULE

  if ($('.quicklink-slider').length && typeof $.fn.slick === 'function') {
    $('.quicklink-slider').each(function() {
      const slidesLength = parseInt($(this).data('slides-count'));

      if(slidesLength > 2) {
        $(this).slick({
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          responsive: [
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    })
  }

  // IMAGE BANNER MODULE
  if ($('.image-banner-slider').length && typeof $.fn.slick === 'function') {
    const slidesCount = $('.image-banner-slider').find('.slide').length

    if(slidesCount > 1) {
      $('.image-banner-slider').slick({
        dots: false,
        arrows: true,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 5000,
        slidesToShow: 1,
        slidesToScroll: 1,
      });
    }
  }


  // Collection Filter Toggler
  if($(".facets-toggle-filter").length) {
    $(".facets-toggle-filter").on("click", function () {
      if(window.innerWidth >= 1024) {
        $(this).toggleClass("active");
        $(".facets-vertical .facets-wrapper").toggleClass("active");
      } else {
        $("menu-drawer.mobile-facets__wrapper .mobile-facets__open").trigger("click");
      }
    });
  }

  if($(".facet-filters.sorting").length) {
    $(".facet-filters.sorting .select").click(function() {
      $(this).find(".select-options").toggleClass("active");
    })
  }

  // Initial logo swap on load
  window.addEventListener('load', switchLogoBasedOnWidth);
  // Logo swap on resize

  window.addEventListener('resize', switchLogoBasedOnWidth);


  if ($('facet-filters-form .mobile-facets__summary').length) {
    $('facet-filters-form .mobile-facets__summary').click(function () {
      const parentDetails = $(this).closest('details');
      $('facet-filters-form details').not(parentDetails).removeAttr('open');
    });
  }

  if ($('.menu-drawer__navigation-label').length) {
    $('.menu-drawer__navigation-label').each(function () {
      $(this).click(function () {
        $('.menu-drawer__navigation-label').removeClass('active');
        $(this).addClass('active');
        const id = $(this).data('id');

        if ($(`.menu-drawer__navigation-links__block[data-id="${id}"]`).length) {
          $('.menu-drawer__navigation-links__block').removeClass('active');
          $(`.menu-drawer__navigation-links__block[data-id="${id}"]`).addClass('active');
        }
        updateUnderline();
      });
    });
  }

  $(document).on('click', '.menu-drawer__navigation-link__menu details', function () {
    if (!this.open) {
      $('.menu-drawer__navigation-link__menu details').not(this).prop('open', false);
    }
  });

  $('.header__icons .header__search > details').on('toggle', function () {
    $('.header-outer-wrapper').toggleClass('search-open');

    if ($('.shopify-section.menu-open').length) {
      $('.header header-drawer .menu-drawer-container').removeAttr('open');
      $('.shopify-section.menu-open').removeClass('menu-open');
      $('body').removeClass('overflow-hidden-tablet');
    }
  });

  $('.popup-product-cta').magnificPopup({
    type: 'inline',
    closeOnContentClick: true,
    mainClass: 'product-popup-cta',
  });

  $('.popup-close').on('click', function (e) {
    e.preventDefault();
    $.magnificPopup.close();
  });

  $('.js-toggle-size-modal').magnificPopup({
    type: 'inline',
    mainClass: 'mfp-fade',
    closeOnBgClick: true,
    closeBtnInside: false,
    closeOnContentClick: false,
    alignTop: true,
    removalDelay: 500,
  });

  // Wishlist state
  if (window.SwymCallbacks) {
    window.SwymCallbacks.push(function (swat) {
      if (swat.fetchLists) {
        swat.fetchLists({
          callbackFn: function (lists) {
            if (lists.length && lists[0].listcontents.length) {
              $('.header__icon--wishlist').addClass('has-wishlist-items');
            }
          },
          errorFn: function (error) {
            console.error('Error fetching swym lists:', error);
          },
        });
      }
    });
  }

  // MegaMenus
  var megaMenuTimeout;


  const parentMenuItems = $(".mega-menu__list-grid .mega-menu__list.parent a.has-children");
  const childMenuColumns = $(".child-menu-column");

  parentMenuItems.click(function(e) {
    e.preventDefault();
    const menuTarget = $(this).data('menu-target');
    if($(menuTarget).length) {
      const megaMenuListChildren = $(this).closest(".mega-menu__list-grid").find(".mega-menu__list.children")

      if($(this).hasClass('active')) {
        megaMenuListChildren.removeClass('active');
        $(menuTarget).removeClass('active');
        $(this).removeClass('active');

      } else {
        $('.mega-menu__list.parent a.has-children.active').removeClass("active");

        megaMenuListChildren.addClass('active');
        childMenuColumns.not(menuTarget).removeClass('active');
        $(menuTarget).addClass('active');
        $(this).addClass('active');

      }
    }
  })

  $('.header__inline-menu li').each(function () {
    var $item = $(this);
    var menuHandle = $item.data('menu-handle');
    var $megaMenu = $(".mega-menu[data-menu-handle='" + menuHandle + "']");
    var $header = $('.header-wrapper');
    var $headerOuter = $('.header-outer-wrapper');

    if ($megaMenu.length > 0) {
      $item.on('mouseenter', function () {
        clearTimeout(megaMenuTimeout);
        $('.mega-menu').removeClass('active'); // Remove active class from other menus
        $megaMenu.addClass('active');
        $header.addClass('mega-menu-open');
        $headerOuter.addClass('mega-menu-open');
      });

      $item.on('mouseleave', function () {
        megaMenuTimeout = setTimeout(function () {
          if (!$('.mega-menu:hover').length) {
            $('.mega-menu').removeClass('active');
            $header.removeClass('mega-menu-open');
            $headerOuter.removeClass('mega-menu-open');
          }
        }, 400);
      });

      $megaMenu.on('mouseenter', function () {
        clearTimeout(megaMenuTimeout);
      });

      $megaMenu.on('mouseleave', function () {
        megaMenuTimeout = setTimeout(function () {
          $('.mega-menu').removeClass('active');
          $header.removeClass('mega-menu-open');
          $headerOuter.removeClass('mega-menu-open');
        }, 400);
      });

      $item.on('click', function (e) {
        if ($(window).width() < 1024) {
          e.preventDefault();
          $('.mega-menu').removeClass('active'); // Close other open menus
          $megaMenu.addClass('active');
          $header.addClass('mega-menu-open');
          $headerOuter.addClass('mega-menu-open');
        }
      });

      $(document).on('click', function (e) {
        if (!$(e.target).closest('.header__inline-menu, .mega-menu').length) {
          $('.mega-menu').removeClass('active');
          $header.removeClass('mega-menu-open');
          $headerOuter.removeClass('mega-menu-open');
        }
      });
    }
  })


  // Move Instagram footer link above feed
  function reorderInstafeedElements() {
    const instaFeed = document.getElementById('insta-feed');
      
    if (instaFeed) {
      const bottomLinkWrapper = document.querySelector('.instafeed-bottom-link-wrapper');
      const layoutContainer = instaFeed.querySelector('.instafeed-new-layout-container');
      
      if (bottomLinkWrapper && layoutContainer) {
        layoutContainer.parentNode.insertBefore(bottomLinkWrapper, layoutContainer);

        const link = bottomLinkWrapper.querySelector('a');

        if (link) {
            link.innerHTML = 'Visit Instagram <svg xmlns="http://www.w3.org/2000/svg" width="19.414" height="16.828" viewBox="0 0 19.414 16.828" style="display: inline-block; vertical-align: middle;"><g id="Group_36" data-name="Group 36" transform="translate(908.5 385.914) rotate(180)"><g id="Group_34" data-name="Group 34"><line id="Line_3" data-name="Line 3" x1="7" y2="7" transform="translate(890.5 370.5)" fill="none" stroke="#000" stroke-linecap="square" stroke-width="2"></line><line id="Line_4" data-name="Line 4" x1="7" y1="7" transform="translate(890.5 377.5)" fill="none" stroke="#000" stroke-linecap="square" stroke-width="2"></line></g><line id="Line_5" data-name="Line 5" x1="18" transform="translate(890.5 377.5)" fill="none" stroke="#000" stroke-width="2"></line></g></svg>';
        }
      }
    }
  }

  const instaFeed = document.getElementById('insta-feed');

  if(instaFeed && instaFeed.hasChildNodes()) {
    reorderInstafeedElements()

  } else {
    const observer = new MutationObserver(function(mutations) {
      const instaFeed = document.getElementById('insta-feed');
      if (instaFeed && instaFeed.hasChildNodes()) {
        reorderInstafeedElements();
        observer.disconnect();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }
})


function handleStickyHeader() {
  var $stickyHeader = $('sticky-header');
  if (!$stickyHeader.length) return;

  var offsetTop = $stickyHeader.offset().top;

  $(window).on('scroll', function () {
    if ($(window).scrollTop() >= offsetTop) {
      $stickyHeader.addClass('is-sticky');
    } else {
      $stickyHeader.removeClass('is-sticky');
    }
  });
}
